import * as React from "react";
const SVGComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7.546}
    height={10.872}
    viewBox="0 0 7.546 10.872"
    role="img"
    {...props}
  >
    <path
      data-name="Path 675"
      d="M64.3 0a3.777 3.777 0 0 0-3.773 3.773c0 2 3.423 6.681 3.569 6.88l.136.185a.084.084 0 0 0 .136 0l.136-.185c.146-.2 3.569-4.877 3.569-6.88A3.778 3.778 0 0 0 64.3 0zm0 2.422a1.352 1.352 0 1 1-1.352 1.352A1.353 1.353 0 0 1 64.3 2.422z"
      style={{
        fill: "#46799a",
      }}
      transform="translate(-60.531)"
    />
  </svg>
);
export default SVGComponent;
